import { $api } from "../generated/client";

export default function useGetShopEmbedHtmlSuspense(shopifyUrl: string, autoOpen?: boolean) {
	return $api.useSuspenseQuery("get", "/embed-html", {
		params: { query: { shopifyUrl, ...(autoOpen ? { autoOpen: true } : {}) } },
	});
}
